import {
  PRODUCT_PATH,
  CUSTOMER_PATH,
  SALEORDER_PATH,
  DELIVERYPLAN_PATH,
  TASK_PATH,
  MONITOR_PATH,
  DECISIONAIDS_PATH,
  PRODUCT_ATLAS_PATH,
  QUOTATION_PATH,
  CUSTOMER_BUSINESS_OPPORTUNITY_PATH,
} from '@/config/business.config'
export const pageDetailConfig = {
  // 配送行程单（母婴）
  deliverGoodsDetail: { url: 'repository/goodsDelivery' },
  // 资产管理
  assetDetail: { url: '/asset/index' },
  // 产品
  productDetail: { url: PRODUCT_PATH },
  commodityDetail: { url: '/product/commodity' },
  productAtlaDetail: { url: PRODUCT_ATLAS_PATH },
  productPackageDetail: { url: '/product/productPackageList' },
  // 线索
  clueDetail: { url: '/customer/clueList' },
  // 客户
  customerDetail: { url: CUSTOMER_PATH },
  // 商机
  businessDetail: { url: CUSTOMER_BUSINESS_OPPORTUNITY_PATH },
  // 报价单
  quoteDetail: { url: QUOTATION_PATH },
  // 订单
  orderDetail: { url: SALEORDER_PATH },
  // 采购单
  purchaseDetail: { url: '/purchase/purchaseOrder' },
  // 采购 外购拓品
  outsideDetail: { url: '/purchase/outside' },
  // 供应商
  supplierDetail: { url: '/purchase/supplierList' },
  // 发货单
  supplierDeliveryDetail: { url: '/repository/supplierDelivery' },
  // 收货单
  receiveSupplierDeliveryDetail: { url: '/repository/receiveDelivery' },
  // 商品代发
  stockOutDetail: { url: '/repository/stockOut' },
  // 商品退货
  salesReturnDetail: { url: '/repository/salesReturn' },
  // 商品快递索赔
  salesClaimDetail: { url: '/repository/salesClaim' },
  // 发货计划
  deliveryPlanDetail: { url: DELIVERYPLAN_PATH },
  // 发货计划
  todayPlanDetail: { url: '/repository/todayPlan' },
  // 第三方仓库
  thirdRepositoryDetail: { url: '/repository/third' },
  // 第三方仓库调拨
  thirdTransferDetail: { url: '/repository/third/transfer' },
  // 入库单
  repositoryInRecordDetail: { url: '/repository/repositoryRecord' },
  // 出库单
  repositoryOutRecordDetail: { url: '/repository/repositoryRecord' },
  // 箱单
  cartonsDetailDraw: { url: '/repository/repositoryRecord' },
  // 库存盘点
  inventoryDetail: { url: '/repository/record/inventory' },
  // 产品调拨
  transferDetail: { url: '/repository/record/transfer' },
  // 产品组装拆卸
  assembleDetail: { url: '/repository/record/assemble' },
  // 回款计划
  billPlanDetail: { url: '/finance/plan' },
  // 回款明细
  billDetail: { url: '/finance/receivables' },
  // 付款计划
  paymentPlanDetail: { url: '/finance/paymentPlan' },
  // 付款明细
  paymentDetail: { url: '/finance/paymentDetail' },
  // 开票计划
  invoicePlan: { url: '/finance/invoicePlan' },
  // 开票明细
  invoiceDetail: { url: '/finance/invoice' },
  // 任务
  taskDetail: { url: TASK_PATH },
  // 海关企业详情
  enterpriseDetail: { url: MONITOR_PATH },
  // AB客-海关客户详情
  customsCustomerDetai: { url: DECISIONAIDS_PATH },
  // 渠道详情
  channelDetail: { url: '/marketing/channel' },
  // 竞对渠道详情
  competeChannelDetail: { url: '/marketing/channelCompete' },
  // 仓储体积详情
  storageVolumeDetail: { url: '/logs/storageVolume' },
  // bom详情
  bomDetail: { url: '/factory/bom/index' },
  // 工序详情
  processDetail: { url: '/factory/technology/process' },
  // 工艺详情
  technologyDetail: { url: '/factory/technology/index' },
  // 生产计划详情
  proPlanDetail: { url: '/factory/productionPlan' },
  // 生产工单详情
  proOrderDetail: { url: '/factory/productionOrder' },
  // 生产工序详情
  proProcessDetail: { url: '/factory/execute/process' },
  // 报工单详情
  workTicketDetail: { url: '/factory/execute/workticket' },
  // 领料单详情
  matPickDetail: { url: '/factory/materiel/picking' },
  // 委外单详情
  entrustOrderDetail: { url: '/factory/entrust/order' },
  // 委外单详情
  entrustProcessDetail: { url: '/factory/entrust/process' },
  //发货订单（家具）
  furnitureOrderDetail: { url: '/repository/deliveryOrder' },
  // 质检详情
  qcDetail: { url: '/factory/qc/list' },
  // 快递详情
  expressDetail: { url: '/repository/express' },
  // 账单详情
  periodCustomerDetail: { url: '/finance/reconciliation' },
  // 设备详情
  deviceDetail: { url: '/device/index' },
  // 模具组详情
  mouldGroupDetail: { url: '/device/group' },
  // 模具供应商详情
  mouldSupplierDetail: { url: '/device/supplier' },
  // 模具样品详情
  sampleDetail: { url: '/device/sample' },
  // 日程任务详情
  calendarDetail: { url: '/mytask/mytask' },
  // 日程任务详情
  calendarDetail2: { url: '/mytask/mytask' },
  // 任务模板详情
  tasktplDetail: { url: '/setting/tasktpl' },
}
